export const MAX_CONTENT_WIDTH = '768px';

export const MediaQuery = {
  MOBILE: '(max-width: 767px)',
  TABLET_UP: '(min-width: 768px)',
  DESKTOP_UP: '(min-width: 1200px)',
} as const;
